import {Box, Stack, Typography} from "@mui/material";
import type {ProvenanceLink} from "../../../../../sdo/ProvenanceLink.ts";
import ProvenanceView from "./ProvenanceView.tsx";

interface ProvenanceCardProps {
    provenanceLink: ProvenanceLink;
}

function ProvenanceCard({provenanceLink}: ProvenanceCardProps) {
    const typeLabel = provenanceLink.sourceType && provenanceLink.sourceType.trim().length > 0
        ? provenanceLink.sourceType
        : "Provenance";

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "stretch",
            width: "100%",
            minWidth: "500px",
            background: "linear-gradient(155deg, rgba(0, 71, 106, 0.45) 0%, rgba(0, 38, 53, 0.45) 25%, rgba(0, 0, 0, 0.45) 90%, rgba(0, 0, 0, 0.55) 100%)",
            borderRadius: "15px",
            border: "0.5px solid #3F464F",
            overflow: "hidden",
            transition: "border-color 0.2s",
        }}>
            {/* Center: header + content (no left/right action panels — view-only) */}
            <Box sx={{flex: 1, minWidth: 0, display: "flex", flexDirection: "column", background: "linear-gradient(180deg, rgba(22, 30, 38, 0.9) 0%, rgba(14, 18, 24, 0.95) 100%)"}}>
                {/* Header row */}
                <Box sx={{borderBottom: "1px solid rgba(63, 70, 79, 0.5)", padding: "8px 12px"}}>
                    <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={1.5} sx={{
                        width: "100%",
                        maxWidth: 760,
                        mx: "auto",
                    }}>
                        <img src="/images/provenance.svg" width={24} height={24} alt="Provenance" style={{opacity: 0.9}}/>
                        <Typography sx={{
                            color: "#f2f5fa",
                            fontWeight: 700,
                            fontSize: "1.00rem",
                            whiteSpace: "nowrap",
                        }}>
                            {typeLabel}
                        </Typography>
                        <Box sx={{
                            width: "1px",
                            height: "20px",
                            backgroundColor: "rgba(112, 147, 160, 0.4)",
                            marginLeft: "4px",
                        }}/>
                        <Typography sx={{
                            color: "rgba(242, 245, 250, 0.45)",
                            fontSize: "0.75rem",
                            fontWeight: 700,
                            whiteSpace: "nowrap",
                        }}>
                            Source:
                        </Typography>
                        <Typography sx={{
                            color: "#02cfee",
                            fontSize: "0.75rem",
                            fontWeight: 700,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "420px",
                        }}>
                            {provenanceLink.sourcePath || "—"}
                        </Typography>
                    </Stack>
                </Box>

                {/* Content area (view-only) */}
                <Box sx={{padding: "8px 12px", minHeight: "40px"}}>
                    <ProvenanceView provenanceLink={provenanceLink}/>
                </Box>
            </Box>
        </Box>
    );
}

export default ProvenanceCard;
